import React from 'react';

const SagittariusIcon = ({ width = '80', height = '80', color = '#f1c40f' }) => (
  <svg width={width} height={height} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M20 80L80 20" stroke={color} strokeWidth="5" strokeLinecap="round"/>
    <path d="M50 50L80 20" stroke={color} strokeWidth="5" strokeLinecap="round"/>
    <path d="M40 90L10 60" stroke={color} strokeWidth="5" strokeLinecap="round"/>
  </svg>
);

export default SagittariusIcon;
